import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Background = ApplicationRecord.extend({
  static: {
    jsonapiType: 'backgrounds',
  },
  attrs: {
    color: attr(),
    letter: attr(),
    hidden: attr(),
    imageUrl: attr(),
    productTypeNames: attr(),
    orderPackages: hasMany(),
    backgroundSet: hasMany(),
  }
});

export default Background;
